var _circle, _path, _path2, _circle2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconUser = function SvgIconUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.003,
    cy: 18.003,
    r: 4.002,
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 14.3a8.53 8.53 0 1 0-5.22 5.22",
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.998a2.223 2.223 0 1 1 0 4.446 2.223 2.223 0 0 1 0-4.446m3.952 7.912a2.079 2.079 0 0 0-1.913-1.242H9.462a2.119 2.119 0 0 0-1.964 1.334",
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.003,
    cy: 18.003,
    r: 4.002,
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.476 17.266-1.843 1.843-1.104-1.107",
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconUser);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIxOC4wMDMiIGN5PSIxOC4wMDMiIHI9IjQuMDAyIiBzdHJva2U9IiMwNjEyMzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0xOS41MiAxNC4zYTguNTMgOC41MyAwIDEgMC01LjIyIDUuMjIiIHN0cm9rZT0iIzA2MTIzMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTExLjUgNi45OThhMi4yMjMgMi4yMjMgMCAxIDEgMCA0LjQ0NiAyLjIyMyAyLjIyMyAwIDAgMSAwLTQuNDQ2bTMuOTUyIDcuOTEyYTIuMDc5IDIuMDc5IDAgMCAwLTEuOTEzLTEuMjQySDkuNDYyYTIuMTE5IDIuMTE5IDAgMCAwLTEuOTY0IDEuMzM0IiBzdHJva2U9IiMwNjEyMzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxjaXJjbGUgY3g9IjE4LjAwMyIgY3k9IjE4LjAwMyIgcj0iNC4wMDIiIHN0cm9rZT0iIzA2MTIzMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0ibTE5LjQ3NiAxNy4yNjYtMS44NDMgMS44NDMtMS4xMDQtMS4xMDciIHN0cm9rZT0iIzA2MTIzMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";